import { generateGuid } from '../../utils/helpers/guid'

function normalizeAlertMessage(value, fallback = '') {
  if (Array.isArray(value)) {
    const first = value.find((x) => typeof x === 'string' && x.trim())
    return first ? first.trim() : fallback
  }
  if (value && typeof value === 'object') {
    if (value.message) return normalizeAlertMessage(value.message, fallback)
    if (value.error) return normalizeAlertMessage(value.error, fallback)
    if (value.errors) return normalizeAlertMessage(value.errors, fallback)
    return fallback
  }
  if (typeof value === 'string') {
    const text = value.trim()
    if (!text) return fallback
    if (text.startsWith('{') || text.startsWith('[')) {
      try {
        return normalizeAlertMessage(JSON.parse(text), fallback) || text
      } catch {
        return text
      }
    }
    return text
  }
  if (value == null) return fallback
  return String(value)
}

export default {
  namespaced: true,
  state: () => ({
    alert: null,
  }),
  getters: {
    alert: (state) => state.alert,
  },
  mutations: {
    setAlertMessage(state, alert) {
      state.alert = {
        ...alert,
        message: normalizeAlertMessage(alert?.message, 'No se pudo completar la operación.'),
        id: generateGuid(),
      }
    },
  },
  actions: {
    setAlert({ commit }, alert) {
      commit('setAlertMessage', alert)
    },
  },
}
